export default __webpack_public_path__ + "static/NREDCAPLOGO-81f0faf0b25b158e1fec59bf3d6b035a.png";